import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { DialogType, SOChannel, SoStageId, TypeIds } from "../constants/constants";
import { DatePipe } from "@angular/common";
import { Status } from "../../constants/constants";
import { Observable, lastValueFrom, map } from "rxjs";
import { SalesOrderService } from "../sales-order.service";
import { SettingService } from "src/app/configurations/inventory/setting/setting.service";
import { OrderSectionsService } from "src/app/modules/shared/services/order-section.service";
import { AppMainComponent } from "src/app/app.main.component";

@Injectable({
    providedIn: "root",
})
export class UtilityService {
    private iSettings: any[] = [];
    setISettings(iSettings: any[]) {
        this.iSettings = iSettings;
    }
    getISettings(): any[] {
        return this.iSettings;
    }

    constructor(
        public app: AppMainComponent,
        public datepipe: DatePipe,
        private salesOrderService: SalesOrderService,
        private settingService: SettingService,
        private orderSectionsService: OrderSectionsService,
    ) {}

    getCustomAttributesForAddEdit(customFields) {
        const customattributeList = [];
        const cf = _.cloneDeep(customFields);
        Object.keys(cf).forEach((key) => {
            const dataArr = cf[key];
            if (dataArr && dataArr.length > 0) {
                dataArr?.forEach((element) => {
                    if ((element.formControl.name == "FileUpload" || element.formControl.name == "Picture") && element.customUploadedFiles.length > 0) {
                        customattributeList.push(element);
                    } else if (element.value) {
                        customattributeList.push(element);
                    }
                });
            }
        });
        return customattributeList;
    }

    checkvalidation(customFields) {
        let isValid = true;
        const cf = _.cloneDeep(customFields);
        Object.keys(cf).forEach((key) => {
            const dataArr = cf[key];
            if (dataArr && dataArr.length > 0) {
                dataArr?.forEach((element) => {
                    if (element.formControl.name == "TreeSelect") {
                        // later
                    } else if (element.isRequired) {
                        if (element.formControl.name == "FileUpload" || element.formControl.name == "Picture") {
                            if (element?.customUploadedFiles?.length == 0) {
                                isValid = false;
                            }
                        } else if (!element.value) {
                            isValid = false;
                        }
                    }
                });
            }
        });
        return isValid;
    }

    getAvailQty(wareHouse, wareHouseId, productId) {
        let totalAvailQty = 0;
        const whDetailDto = wareHouse?.length ? wareHouse?.filter((w) => w.warehouseId == wareHouseId && w.productId == productId)[0] : null;
        if (whDetailDto && whDetailDto.availQty) {
            totalAvailQty = whDetailDto.availQty;
        }
        return totalAvailQty;
    }

    getPickedQty(availableQty, ordQty) {
        let pickQty = 0;
        if (availableQty >= 1 && ordQty >= availableQty) {
            pickQty = availableQty;
        } else if (availableQty >= 1 && ordQty < availableQty) {
            pickQty = ordQty;
        } else if (availableQty <= 0 && ordQty > availableQty) {
            pickQty = ordQty;
        }
        return pickQty;
    }

    getKitProductsPickQty(ordQty, parentOrdQty, parentAvailableQty) {
        // kit products pick qty is based on parent product's ordqty & availableQty
        // console.log('Kit product -->>', ordQty, parentOrdQty, parentAvailableQty);
        // let pickQty = ((Number(ordQty) / Number(parentOrdQty)) * Number(parentAvailableQty));
        let pickQty = Number(ordQty) * Number(parentOrdQty);
        return pickQty;
    }

    /**
     * Checking templates section and insert proper custom attribute inside that section
     * Estimate, SalesOrder, Invoice has same common template
     */
    getCustomAttributesForCommon(templates: any, allCustomAttributes: any) {
        const customAtributes = {
            billing_address_item: [],
            shipping_address_item: [],
            misc_item: [],
            section_item: [],
            footer_item: [],
            message_item: [],
            other1_item: [],
            other2_item: [],
            other3_item: [],
        };

        if (allCustomAttributes && allCustomAttributes.length > 0) {
            const data = _.cloneDeep(allCustomAttributes);
            const cFields = data.filter((c) => c.section.typeId == 0);
            cFields?.forEach((fld) => {
                if (fld.isDelete && fld.section && fld.section.code) {
                    let check = false;
                    switch (fld.section.code) {
                        case "labels_billaddress":
                            check = templates["labels_billaddress"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_billaddress"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_billaddress"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.billing_address_item.push(fld);
                            }
                            break;
                        case "labels_shipaddress":
                            check = templates["labels_shipaddress"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_shipaddress"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_shipaddress"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.shipping_address_item.push(fld);
                            }
                            break;
                        case "labels_misc":
                            check = templates["labels_misc"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_misc"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_misc"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.misc_item.push(fld);
                            }
                            break;
                        case "labels_section":
                            check = templates["labels_section"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_section"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_section"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.section_item.push(fld);
                            }
                            break;
                        case "labels_footer":
                            check = templates["labels_footer"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_footer"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_footer"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.footer_item.push(fld);
                            }
                            break;
                        case "labels_message":
                            check = templates["labels_message"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_message"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_message"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.message_item.push(fld);
                            }
                            break;
                        case "labels_estimate_other1":
                            check = templates["labels_estimate_other1"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_estimate_other1"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_estimate_other1"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.other1_item.push(fld);
                            }
                            break;
                        case "labels_estimate_other2":
                            check = templates["labels_estimate_other2"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_estimate_other2"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_estimate_other2"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.other2_item.push(fld);
                            }
                            break;
                        case "labels_estimate_other3":
                            check = templates["labels_estimate_other3"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_estimate_other3"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                fld.code = templates["labels_estimate_other3"]?.find((el) => el.id == fld.id)?.code ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.other3_item.push(fld);
                            }
                            break;
                    }
                }
            });
        }
        return customAtributes;
    }

    /**
     * Checking Credit memo templates section and insert proper custom attribute inside that section
     */
    getCustomerRMACustomAttributes(templates: any, allCustomAttributes: any) {
        const customAttributes = {
            billing_address_item: [],
            shipping_address_item: [],
            misc_item: [],
            section_item: [],
            footer_item: [],
            message_item: [],
            other1_item: [],
            other2_item: [],
            other3_item: [],
        };

        if (allCustomAttributes && allCustomAttributes.length > 0) {
            const data = _.cloneDeep(allCustomAttributes);
            const fields = data.filter((x) => x.section.typeId == 5);
            fields.forEach((field) => {
                if (field.isDelete && field.section && field.section.code && templates[field.section.code]) {
                    const template = templates[field.section.code].find((el) => el.id == field.id && el.sectionId == field.section.id);
                    if (template?.isChecked) {
                        field.isChecked = true;
                        if (field.formControl?.name == "FileUpload" || field.formControl?.name == "Picture") {
                            field.customUploadedFiles = [];
                        }
                        const labels = "labels_";
                        const labelsRma = "labels_customerreturn_";
                        if (field.section.code.startsWith(labelsRma)) {
                            const key = field.section.code.substring(labelsRma.length) + "_item";
                            if (customAttributes[key]) {
                                customAttributes[key].push(field);
                            }
                        } else if (field.section.code.startsWith(labels)) {
                            const key = field.section.code.substring(labels.length) + "_item";
                            if (customAttributes[key]) {
                                customAttributes[key].push(field);
                            }
                        }
                    }
                }
            });
        }
        return customAttributes;
    }

    /**
     * Checking Credit memo templates section and insert proper custom attribute inside that section
     */
    getCreditMemoCustomAttributes(templates: any, allCustomAttributes: any) {
        const customAtributes = {
            billing_address_item: [],
            shipping_address_item: [],
            misc_item: [],
            section_item: [],
            footer_item: [],
            message_item: [],
            other1_item: [],
            other2_item: [],
            other3_item: [],
        };

        if (allCustomAttributes && allCustomAttributes.length > 0) {
            const data = _.cloneDeep(allCustomAttributes);
            const cFields = data.filter((c) => c.section.typeId == 6);
            cFields?.forEach((fld) => {
                if (fld.isDelete && fld.section && fld.section.code) {
                    let check = false;

                    switch (fld.section.code) {
                        case "labels_billaddress":
                            check = templates["labels_billaddress"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_billaddress"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.billing_address_item.push(fld);
                            }
                            break;
                        case "labels_shipaddress":
                            check = templates["labels_shipaddress"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_shipaddress"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.shipping_address_item.push(fld);
                            }
                            break;
                        case "labels_misc":
                            check = templates["labels_misc"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_misc"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.misc_item.push(fld);
                            }
                            break;
                        case "labels_section":
                            check = templates["labels_section"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_section"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.section_item.push(fld);
                            }
                            break;
                        case "labels_footer":
                            check = templates["labels_footer"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_footer"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.footer_item.push(fld);
                            }
                            break;
                        case "labels_message":
                            check = templates["labels_message"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_message"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.message_item.push(fld);
                            }
                            break;
                        case "labels_creditmemo_other1":
                            check = templates["labels_creditmemo_other1"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_creditmemo_other1"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.other1_item.push(fld);
                            }
                            break;
                        case "labels_creditmemo_other2":
                            check = templates["labels_creditmemo_other2"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_creditmemo_other2"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.other2_item.push(fld);
                            }
                            break;
                        case "labels_creditmemo_other3":
                            check = templates["labels_creditmemo_other3"]?.find((el) => el.id == fld.id && el.sectionId == fld.section.id)?.isChecked;
                            if (check) {
                                fld.isChecked = check;
                                fld.name = templates["labels_creditmemo_other3"]?.find((el) => el.id == fld.id)?.labelname ?? "";
                                if (fld.formControl?.name == "FileUpload") {
                                    fld.customUploadedFiles = [];
                                } else if (fld.formControl?.name == "Picture") {
                                    fld.customUploadedFiles = [];
                                }
                                customAtributes.other3_item.push(fld);
                            }
                            break;
                    }
                }
            });
        }
        return customAtributes;
    }

    getSalesOrderProductsSerialDetails(purchaseListTB = []) {
        const trackingDetails = [];
        purchaseListTB?.forEach((product) => {
            if (product?.typeId == TypeIds.BundleTypeId || product?.typeId == TypeIds.KitTypeId) {
                product?.salesOrderBundleDetail?.forEach((p) => {
                    trackingDetails.push(this.getSerialDetailsObj(p?.itemNo, p?.salesOrderBundleProductSerialDetail));
                    if (p.salesOrderBundleDetail?.length > 0) {
                        for (let kp of p?.salesOrderBundleDetail) {
                            trackingDetails.push(this.getSerialDetailsObj(kp?.itemNo, kp?.salesOrderBundleProductSerialDetail));
                        }
                    }
                });
            } else {
                trackingDetails.push(this.getSerialDetailsObj(product?.itemNo, product?.salesOrderSerialDetails));
            }
        });
        return trackingDetails;
    }

    getInvoiceProductsSerialDetails(purchaseListTB = []) {
        const trackingDetails = [];
        purchaseListTB?.forEach((product) => {
            if ((product?.typeId == TypeIds.BundleTypeId || product?.typeId == TypeIds.KitTypeId) && product.invoiceBundleDetail?.length > 0) {
                product?.invoiceBundleDetail?.forEach((p) => {
                    trackingDetails.push(this.getSerialDetailsObj(p?.itemNo, p?.invoiceBundleProductSerialDetail));
                    if (p.invoiceBundleDetail?.length > 0) {
                        for (let kp of p.invoiceBundleDetail) {
                            trackingDetails.push(this.getSerialDetailsObj(kp?.itemNo, kp?.invoiceBundleProductSerialDetail));
                        }
                    }
                });
            } else {
                trackingDetails.push(this.getSerialDetailsObj(product?.itemNo, product?.invoiceProductSerialDetails));
            }
        });
        return trackingDetails;
    }

    checkforBulkImportInvoice(invoiceProducts) {
        for (let prd of invoiceProducts) {
            if (prd.trackingEnabled) {
                return true;
            }
            for (let bundle of prd.invoiceBundleDetail) {
                if (bundle.trackingEnabled) {
                    return true;
                }
                for (let kp of bundle.invoiceBundleDetail) {
                    if (kp.trackingEnabled) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getCreditMemoProductsSerialDetails(purchaseListTB = []) {
        const trackingDetails = [];
        purchaseListTB?.forEach((product) => {
            if ((product?.typeId == TypeIds.BundleTypeId || product?.typeId == TypeIds.KitTypeId) && product.creditMemoBundleDetail?.length > 0) {
                product?.creditMemoBundleDetail?.forEach((p) => {
                    trackingDetails.push(this.getSerialDetailsObj(p?.itemNo, p?.cmBundleProductSerialDetail));
                    if (p.creditMemoBundleDetail?.length > 0) {
                        for (let kp of p.creditMemoBundleDetail) {
                            trackingDetails.push(this.getSerialDetailsObj(kp?.itemNo, kp?.cmBundleProductSerialDetail));
                        }
                    }
                });
            } else {
                trackingDetails.push(this.getSerialDetailsObj(product?.itemNo, product?.creditMemoProductSerialDetails));
            }
        });
        return trackingDetails;
    }

    getSerialDetailsObj(name = "", trckDetails = []): any {
        const groupedData: any[] = [];
        for (let i = 0; i < trckDetails.length; i += 3) {
            groupedData.push(trckDetails.slice(i, i + 3));
        }
        const obj = {
            itemName: name,
            serialDetails: groupedData,
        };
        return obj;
    }

    getOunceValue(weight, code) {
        let ounce = weight;
        switch (code) {
            case "POUND":
                ounce = weight * 16;
                break;
            case "KILOGRAM":
                ounce = weight * 35.274;
                break;
            case "STONE":
                ounce = weight * 224;
                break;
        }
        return ounce;
    }

    setPricePerQty(tier, qty) {
        if (qty < tier.qtyPrice[1]?.qty) {
            return tier.qtyPrice[0].price;
        } else if (qty > tier.qtyPrice[1]?.qty - 1 && qty < tier.qtyPrice[2]?.qty) {
            return tier.qtyPrice[1].price;
        } else if (qty > tier.qtyPrice[2]?.qty - 1 && qty < tier.qtyPrice[3]?.qty) {
            return tier.qtyPrice[2].price;
        } else if (qty > tier.qtyPrice[3]?.qty - 1 && qty < tier.qtyPrice[4]?.qty) {
            return tier.qtyPrice[3].price;
        } else if (qty > tier.qtyPrice[4]?.qty - 1 && qty < tier.qtyPrice[5]?.qty) {
            return tier.qtyPrice[4].price;
        } else if (qty >= tier.qtyPrice[5]?.qty) {
            return tier.qtyPrice[5]?.price;
        } else {
            return tier.qtyPrice[tier.qtyPrice?.length - 1]?.price;
        }
    }

    applyPriceBook(aggregateDiscount, item, qty) {
        if (!item.isCustom) {
            if (aggregateDiscount) {
                /**
                 * Set Aggregate Discount.
                 */
                if (!item.isCustom && item.accountPriceTier?.length > 1) {
                    if (item.discountTypeName == "Discount By Product Group") {
                        const qtyTier = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        item.price = Number(this.setPricePerQty(qtyTier, qty));
                        const group = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                        const groupDiscount = Number(item.price * (group?.markUp / 100));
                        item.price = item.price + (isNaN(groupDiscount) ? 0 : groupDiscount);
                        return item.price;
                    } else if (item.discountTypeName == "Discount By Qty") {
                        const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                        item.price = Number(this.setPricePerQty(selectedAccountTier, qty));
                        const group = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        const groupDiscount = Number(item.price * (group?.markUp / 100));
                        item.price = item.price + (isNaN(groupDiscount) ? 0 : groupDiscount);
                        return item.price;
                    }
                } else if (!item.isCustom && item.accountPriceTier?.length == 1) {
                    //Either Tier Or Group
                    const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                    item.price = selectedAccountTier?.qtyPrice?.length > 0 ? this.setPricePerQty(selectedAccountTier, qty) : item.price;
                    return item.price;
                }
            } else {
                /**
                 * Set Price Per Product based on Ordered Qty and Product Pricebook.
                 */
                if (!item.isCustom && item.accountPriceTier?.length > 1) {
                    let tierPrice;
                    let groupPrice;
                    if (item.discountTypeName == "Discount By Product Group") {
                        groupPrice = Number(qty * item.originalprice);
                        const qtyTier = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        tierPrice = qtyTier?.qtyPrice?.length > 0 && Number(qty * this.setPricePerQty(qtyTier, qty));
                    } else if (item.discountTypeName == "Discount By Qty") {
                        const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                        tierPrice = Number(qty * this.setPricePerQty(selectedAccountTier, qty));
                        const group = item.accountPriceTier?.filter((tier) => tier.tierId != item.selectedTierId)[0];
                        groupPrice = Number(qty * group?.calculatedPricePerQty);
                    }
                    //Apply discount Type based on minimum pricePerProduct
                    if (groupPrice > tierPrice) {
                        item.price = isNaN(Number(tierPrice / qty)) ? item.price : Number(tierPrice / qty);
                        return item.price;
                    } else {
                        item.price = isNaN(Number(groupPrice / qty)) ? item.price : Number(groupPrice / qty);
                        return item.price;
                    }
                } else if (!item.isCustom && item.accountPriceTier?.length == 1) {
                    //Either Tier Or Group
                    const selectedAccountTier = item.accountPriceTier?.filter((tier) => tier.tierId == item.selectedTierId)[0];
                    item.price = selectedAccountTier?.qtyPrice?.length > 0 ? this.setPricePerQty(selectedAccountTier, qty) : item.price;
                    return item.price;
                }
            }
        } else {
            return item.price;
        }
    }

    parseSoProductsListForOverview(salesOrder, discounts) {
        const products = [];
        const salesOrderObj = _.cloneDeep(salesOrder);
        salesOrderObj?.salesOrderProducts?.forEach((p) => {
            const uom = p?.product?.productUOM?.filter((po) => po.unitOfMeasureId == p.productUOMId)[0];
            const pDiscType = discounts?.filter((v) => v.id == p.discountId)[0];
            const totalAvailQty = this.getAvailQty(p.productWarehouseDetailDTO, salesOrder.warehouseId, p.productId);

            // bundle items
            const bundleDetail = [];
            p?.salesOrderBundleDetail?.forEach((b) => {
                // ki under kit items
                const kitDetail = [];
                b?.childSalesOrderBundleDetail?.forEach((kp) => {
                    const ku = kp?.product?.productUOM?.filter((o) => o.unitOfMeasureId == kp.productUOMId)[0];
                    const kDiscType = discounts?.filter((v) => v.id == kp.discountId)[0];
                    const ktotalAvailQty = this.getAvailQty(kp.productWarehouseDetailDTO, salesOrder.warehouseId, kp.subProductId);
                    const kserialDetails = this.prepareSalesOrderSerialDetailsData(kp.salesOrderBundleProductSerialDetail);
                    const kObj = {
                        ...kp,
                        itemNo: kp?.product?.itemNo || "",
                        hsnsac: kp?.product?.hsnsac || "",
                        name: kp?.product?.name || "",
                        typeId: kp.product?.typeId,
                        qty: kp.quantity,
                        shippedQty: kp.shippedQty,
                        rate: kp.pricePerProduct,
                        amount: kp.totalAmount,
                        uom: ku?.uomDetail?.description || "",
                        discountType: kDiscType,
                        taxType: kp.tax,
                        discount: kp.discountAmount,
                        discountPercentage: kDiscType?.type?.description == "%" ? (kp.discountRate ?? 0) : 0,
                        taxAmount: kp.taxRate,
                        availableQty: ktotalAvailQty,
                        trackingEnabled: kp.product?.isTrackingRequired,
                        salesOrderBundleProductSerialDetail: kp.salesOrderBundleProductSerialDetail ? kp.salesOrderBundleProductSerialDetail : [],
                        serialCount: kp.salesOrderBundleProductSerialDetail ? kp.salesOrderBundleProductSerialDetail?.length : 0,
                        selectedBin: kp.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == kp.binId),
                        lotNumber: kserialDetails?.lotNumber ?? "",
                        revisionNumber: kserialDetails?.revisionNumber ?? "",
                        serialNumber: kserialDetails?.serialNumber ?? "",
                    };
                    kitDetail.push(kObj);
                });
                const u = b?.product?.productUOM?.filter((o) => o.unitOfMeasureId == b.productUOMId)[0];
                const bDiscType = discounts?.filter((v) => v.id == b.discountId)[0];
                const btotalAvailQty = this.getAvailQty(b.productWarehouseDetailDTO, salesOrder.warehouseId, b.subProductId);
                const bserialDetails = this.prepareSalesOrderSerialDetailsData(b.salesOrderBundleProductSerialDetail);
                const bObj = {
                    ...b,
                    itemNo: b?.product?.itemNo || "",
                    hsnsac: b?.product?.hsnsac || "",
                    name: b?.product?.name || "",
                    typeId: b.product?.typeId,
                    qty: b.quantity,
                    shippedQty: b.shippedQty,
                    rate: b.pricePerProduct,
                    amount: b.totalAmount,
                    uom: u?.uomDetail?.description || "",
                    discountType: bDiscType,
                    taxType: b.tax,
                    discount: b.discountAmount,
                    discountPercentage: bDiscType?.type?.description == "%" ? (b.discountRate ?? 0) : 0,
                    taxAmount: b.taxRate,
                    availableQty: btotalAvailQty,
                    trackingEnabled: b.product?.isTrackingRequired,
                    salesOrderBundleProductSerialDetail: b.salesOrderBundleProductSerialDetail ? b.salesOrderBundleProductSerialDetail : [],
                    serialCount: b.salesOrderBundleProductSerialDetail ? b.salesOrderBundleProductSerialDetail?.length : 0,
                    selectedBin: b.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == b.binId),
                    salesOrderBundleDetail: kitDetail,
                    show: false,
                    lotNumber: bserialDetails?.lotNumber ?? "",
                    revisionNumber: bserialDetails?.revisionNumber ?? "",
                    serialNumber: bserialDetails?.serialNumber ?? "",
                };
                bundleDetail.push(bObj);
            });

            // product
            const serialDetails = this.prepareSalesOrderSerialDetailsData(p.salesOrderSerialDetail);
            const pObj = {
                ...p,
                itemNo: p?.product?.itemNo ?? "",
                hsnsac: p?.product?.hsnsac ?? "",
                name: p?.product?.name ?? "",
                qty: p.quantity,
                shippedQty: p.shippedQty,
                rate: p.pricePerProduct,
                amount: p.totalAmount,
                uom: uom?.uomDetail?.description,
                availableQty: totalAvailQty,
                salesOrderBundleDetail: bundleDetail,
                typeId: p.product.typeId,
                discountType: pDiscType,
                taxType: p.tax,
                discount: p.discountAmount,
                discountPercentage: pDiscType?.type?.description == "%" ? (p.discountRate ?? 0) : 0,
                taxAmount: p.taxRate,
                salesOrderSerialDetails: p.salesOrderSerialDetail ? p.salesOrderSerialDetail : [],
                serialCount: p.salesOrderSerialDetail ? p.salesOrderSerialDetail?.length : 0,
                trackingEnabled: p.product?.isTrackingRequired,
                selectedBin: p.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == p.binId),
                lotNumber: serialDetails?.lotNumber ?? "",
                revisionNumber: serialDetails?.revisionNumber ?? "",
                serialNumber: serialDetails?.serialNumber ?? "",
            };
            products.push(pObj);
        });
        return products;
    }

    checkforBulkImportSO(soProducts) {
        for (let prd of soProducts) {
            if (prd.trackingEnabled) {
                return true;
            }
            for (let bundle of prd?.salesOrderBundleDetail) {
                if (bundle.trackingEnabled) {
                    return true;
                }
                for (let kp of bundle?.salesOrderBundleDetail) {
                    if (kp.trackingEnabled) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getBinName(binList, binId) {
        const binName = binList?.filter((bin) => bin.binId == binId).map((binNm) => binNm.binName)[0];
        return binName;
    }

    prepareEstimateOverviewProductsList(estimate, discounts) {
        return (estimate?.estimateProducts || []).map((product) => {
            const uom = product.product?.productUOM?.find((po) => po.unitOfMeasureId == product.productUOMId);
            const totalAvailQty = product.productWarehouseDetailDTO.reduce((acc, e) => acc + e.availQty, 0);
            const pDiscType = discounts?.find((v) => v.id == product.discountId);
            //Bundle Product
            const bundleDetail = (product.estimateBundleDetail || []).map((bundle) => {
                //Kit under kit Product
                const kitDetail = (bundle.childEstimateBundleDetail || []).map((kp) => {
                    const ku = kp.product?.productUOM?.find((o) => o.unitOfMeasureId == kp.productUOMId);
                    const kDiscType = discounts?.find((v) => v.id == kp.discountId);
                    return {
                        ...kp,
                        itemNo: kp?.product?.itemNo ?? "",
                        hsnsac: kp?.product?.hsnsac ?? "",
                        name: kp?.product?.name ?? "",
                        qty: kp.quantity,
                        rate: kp.pricePerProduct,
                        amount: kp.totalAmount,
                        uom: ku?.uomDetail?.description,
                        discountType: kDiscType,
                        taxType: kp.tax,
                        discount: kp.discountAmount,
                        taxAmount: kp.taxRate,
                    };
                });
                const u = bundle.product?.productUOM?.find((o) => o.unitOfMeasureId == bundle.productUOMId);
                const bDiscType = discounts?.find((v) => v.id == bundle.discountId);
                return {
                    ...bundle,
                    itemNo: bundle?.product?.itemNo ?? "",
                    hsnsac: bundle?.product?.hsnsac ?? "",
                    name: bundle?.product?.name ?? "",
                    qty: bundle.quantity,
                    rate: bundle.pricePerProduct,
                    amount: bundle.totalAmount,
                    uom: u?.uomDetail?.description,
                    discountType: bDiscType,
                    taxType: bundle.tax,
                    discount: bundle.discountAmount,
                    discountPercentage: bDiscType?.type?.description == "%" ? (bundle.discountRate ?? 0) : 0,
                    taxAmount: bundle.taxRate,
                    estimateBundleDetail: kitDetail,
                    show: false,
                };
            });
            return {
                ...product,
                itemNo: product?.product?.itemNo ?? "",
                hsnsac: product?.product?.hsnsac ?? "",
                name: product?.product?.name ?? "",
                qty: product.quantity,
                availableQty: totalAvailQty,
                rate: product.pricePerProduct,
                amount: product.totalAmount,
                uom: uom?.uomDetail?.description,
                estimateBundleDetail: bundleDetail,
                typeId: product.product.typeId,
                discountType: pDiscType,
                taxType: product.tax,
                discount: product.discountAmount,
                discountPercentage: pDiscType?.type?.description == "%" ? (product.discountRate ?? 0) : 0,
                taxAmount: product.taxRate,
            };
        });
    }

    parseInvoiceProductsListForOverview(invoice, discounts) {
        const purchaseList = [];
        const invoiceObj = _.cloneDeep(invoice);
        invoiceObj?.invoiceProducts?.forEach((p) => {
            const uom = p?.product?.productUOM?.filter((po) => po.unitOfMeasureId == p.productUOMId)[0];
            let totalAvailQty = 0;
            p?.productWarehouseDetailDTO?.forEach((e) => {
                totalAvailQty += e.availQty;
            });
            const pDiscType = discounts?.filter((v) => v.id == p.discountId)[0];

            // bundle items
            const bundleDetail = [];
            p?.invoiceBundleDetail?.forEach((b) => {
                // Kit/bundle under kit
                const kitDetail = [];
                b?.childInvoiceBundleDetail?.forEach((k) => {
                    const u = k?.product?.productUOM?.filter((o) => o.unitOfMeasureId == k.productUOMId)[0];
                    const kDiscType = discounts?.filter((v) => v.id == k.discountId)[0];
                    const kserialDetails = this.prepareSalesOrderSerialDetailsData(k.invoiceBundleProductSerialDetail);
                    const obj = {
                        ...k,
                        itemNo: k?.product?.itemNo,
                        hsnsac: k?.product?.hsnsac,
                        typeId: k?.product?.typeId,
                        name: k?.product?.name,
                        qty: k.quantity,
                        shippedQty: k.shippedQty,
                        rate: k.pricePerProduct,
                        amount: k.totalAmount,
                        uom: u?.uomDetail?.description,
                        discountType: kDiscType,
                        taxType: k.tax,
                        discount: k.discountAmount,
                        discountPercentage: kDiscType?.type?.description == "%" ? (k.discountRate ?? 0) : 0,
                        taxAmount: k.taxRate,
                        invoiceBundleProductSerialDetail: k.invoiceBundleProductSerialDetail ? k.invoiceBundleProductSerialDetail : [],
                        trackingEnabled: k.product?.isTrackingRequired,
                        serialCount: k.invoiceBundleProductSerialDetail ? k.invoiceBundleProductSerialDetail?.length : 0,
                        selectedBin: k.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == k.binId),
                        lotNumber: kserialDetails?.lotNumber ?? "",
                        revisionNumber: kserialDetails?.revisionNumber ?? "",
                        serialNumber: kserialDetails?.serialNumber ?? "",
                    };
                    kitDetail.push(obj);
                });

                const u = b?.product?.productUOM?.filter((o) => o.unitOfMeasureId == b.productUOMId)[0];
                const bDiscType = discounts?.filter((v) => v.id == b.discountId)[0];
                const bserialDetails = this.prepareSalesOrderSerialDetailsData(b.invoiceBundleProductSerialDetail);
                const obj = {
                    ...b,
                    itemNo: b?.product?.itemNo,
                    hsnsac: b?.product?.hsnsac,
                    typeId: b?.product?.typeId,
                    invoiceBundleDetail: kitDetail,
                    name: b?.product?.name,
                    qty: b.quantity,
                    shippedQty: b.shippedQty,
                    rate: b.pricePerProduct,
                    amount: b.totalAmount,
                    uom: u?.uomDetail?.description,
                    discountType: bDiscType,
                    taxType: b.tax,
                    discount: b.discountAmount,
                    discountPercentage: bDiscType?.type?.description == "%" ? (b.discountRate ?? 0) : 0,
                    taxAmount: b.taxRate,
                    invoiceBundleProductSerialDetail: b.invoiceBundleProductSerialDetail ? b.invoiceBundleProductSerialDetail : [],
                    trackingEnabled: b.product?.isTrackingRequired,
                    serialCount: b.invoiceBundleProductSerialDetail ? b.invoiceBundleProductSerialDetail?.length : 0,
                    selectedBin: b.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == b.binId),
                    show: false,
                    lotNumber: bserialDetails?.lotNumber ?? "",
                    revisionNumber: bserialDetails?.revisionNumber ?? "",
                    serialNumber: bserialDetails?.serialNumber ?? "",
                };
                bundleDetail.push(obj);
            });

            // product
            const pserialDetails = this.prepareSalesOrderSerialDetailsData(p.invoiceProductSerialDetail);
            const obj = {
                ...p,
                itemNo: p?.product?.itemNo ?? "",
                hsnsac: p?.product?.hsnsac ?? "",
                name: p?.product?.name ?? "",
                qty: p.quantity,
                shippedQty: p.shippedQty,
                rate: p.pricePerProduct,
                amount: p.totalAmount,
                uom: uom?.uomDetail?.description,
                typeId: p.product.typeId,
                invoiceBundleDetail: bundleDetail,
                discountType: pDiscType,
                taxType: p.tax,
                discount: p.discountAmount,
                discountPercentage: pDiscType?.type?.description == "%" ? (p.discountRate ?? 0) : 0,
                taxAmount: p.taxAmount,
                invoiceProductSerialDetails: p.invoiceProductSerialDetail ? p.invoiceProductSerialDetail : [],
                trackingEnabled: p.product?.isTrackingRequired,
                serialCount: p.invoiceProductSerialDetail ? p.invoiceProductSerialDetail?.length : 0,
                selectedBin: p.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == p.binId),
                lotNumber: pserialDetails?.lotNumber ?? "",
                revisionNumber: pserialDetails?.revisionNumber ?? "",
                serialNumber: pserialDetails?.serialNumber ?? "",
            };
            purchaseList.push(obj);
        });
        return purchaseList;
    }

    parseCreditMemoProductsListForOverview(creditMemo, discounts) {
        const creditMemoObj = _.cloneDeep(creditMemo);
        return (creditMemoObj?.creditMemoProducts || []).map((p) => {
            /** bundle items */
            const bundleDetail = (p?.creditMemoBundleDetail || []).map((b) => {
                /** kit under kit items */
                const kitDetail = (b?.childCreditMemoBundleDetail || []).map((kp) => {
                    const ku = kp?.product?.productUOM?.find((o) => o.unitOfMeasureId == kp.productUOMId);
                    const kDiscType = discounts?.find((v) => v.id == kp.discountId);
                    return {
                        ...kp,
                        itemNo: kp?.product?.itemNo,
                        name: kp?.product?.name,
                        qty: kp.quantity,
                        rate: kp.pricePerProduct,
                        amount: kp.totalAmount,
                        uom: ku?.uomDetail?.description,
                        discountType: kDiscType,
                        taxType: kp.tax,
                        discount: kp.discountAmount,
                        discountPercentage: kDiscType?.type?.description == "%" ? (kp.discountRate ?? 0) : 0,
                        taxAmount: this.getTaxAmount(kp, ku?.uomDetail?.value || 1),
                        cmBundleProductSerialDetail: kp.creditMemoBundleProductSerialDetail,
                        trackingEnabled: kp.product?.isTrackingRequired,
                        serialCount: kp.creditMemoBundleProductSerialDetail ? kp.creditMemoBundleProductSerialDetail?.length : 0,
                    };
                });

                const u = b?.product?.productUOM?.find((o) => o.unitOfMeasureId == b.productUOMId);
                const bDiscType = discounts?.find((v) => v.id == b.discountId);
                return {
                    ...b,
                    itemNo: b?.product?.itemNo,
                    name: b?.product?.name,
                    qty: b.quantity,
                    rate: b.pricePerProduct,
                    amount: b.totalAmount,
                    uom: u?.uomDetail?.description,
                    discountType: bDiscType,
                    taxType: b.tax,
                    discount: b.discountAmount,
                    discountPercentage: bDiscType?.type?.description == "%" ? (b.discountRate ?? 0) : 0,
                    taxAmount: this.getTaxAmount(b, u?.uomDetail?.value || 1),
                    cmBundleProductSerialDetail: b.creditMemoBundleProductSerialDetail,
                    trackingEnabled: b.product?.isTrackingRequired,
                    serialCount: b.creditMemoBundleProductSerialDetail ? b.creditMemoBundleProductSerialDetail?.length : 0,
                    creditMemoBundleDetail: kitDetail,
                    show: false,
                };
            });

            /** product */
            const uom = p?.product?.productUOM?.find((po) => po.unitOfMeasureId == p.productUOMId);
            const pDiscType = discounts?.find((v) => v.id == p.discountId);
            return {
                ...p,
                itemNo: p?.product?.itemNo ?? "",
                name: p?.product?.name ?? "",
                qty: p.quantity,
                rate: p.pricePerProduct,
                amount: p.totalAmount,
                uom: uom?.uomDetail?.description,
                typeId: p.product.typeId,
                creditMemoBundleDetail: bundleDetail,
                discountType: pDiscType,
                taxType: p.tax,
                discount: p.discountAmount,
                discountPercentage: pDiscType?.type?.description == "%" ? (p.discountRate ?? 0) : 0,
                taxAmount: this.getTaxAmount(p, uom?.uomDetail?.value || 1),
                creditMemoProductSerialDetails: p.creditMemoProductSerialDetail,
                serialCount: p.creditMemoProductSerialDetail ? p.creditMemoProductSerialDetail?.length : 0,
                trackingEnabled: p.product?.isTrackingRequired,
            };
        });
    }

    checkforBulkImportCM(cmProducts) {
        for (let prd of cmProducts) {
            if (prd.trackingEnabled) {
                return true;
            }
            for (let bundle of prd.creditMemoBundleDetail) {
                if (bundle.trackingEnabled) {
                    return true;
                }
                for (let kp of bundle.creditMemoBundleDetail) {
                    if (kp.trackingEnabled) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getTaxAmount(b, uomValue?) {
        let amount = 0;
        if (b.tax && b.tax.taxRate) {
            amount = b.pickedQty > 0 ? (Number(b.tax.taxRate) / 100) * (Number(b.pickedQty) * Number(uomValue) * Number(b.pricePerProduct)) : (Number(b.tax.taxRate) / 100) * (Number(b.quantity) * Number(uomValue) * Number(b.pricePerProduct));
        }
        return amount;
    }

    checkAvailabilityOfAccountCredit(availableCredit: number, amount: number, accountCreditEnabled: boolean, accountCreditControlId?: number): boolean {
        let accCredit = this.getISettings()?.find((acc) => acc?.name?.toLowerCase() == "account credit");
        if (accCredit && !accCredit.enabled) {
            return true;
        }

        if (accountCreditControlId == 2) {
            return false;
        } else {
            if (accCredit && accCredit.enabled && accountCreditEnabled) {
                return availableCredit > amount;
            } else {
                return true;
            }
        }
    }

    setBin(ordQty, bins) {
        const selectedBin = bins?.find((bin) => bin.availQty > 0 && ordQty <= bin.availQty && bin.isDefault);
        if (selectedBin) {
            return selectedBin;
        } else {
            const defaultBin = bins?.find((bin) => bin.isDefault);
            return defaultBin;
        }
    }

    changeProductsQty(product, qty, data) {
        if (data.channelName == SOChannel.ESTIMATES || data.channelName == SOChannel.INVOICING || (data.channelName == SOChannel.SALES_ORDER && (data.salesOrderStageId == SoStageId.Entered || data.salesOrderStageId == 0))) {
            product.ordQty = Number(product.originalQty) * Number(qty);
            product.totalQuantity = product.ordQty;
        } else if (data.channelName == SOChannel.SALES_ORDER && data.salesOrderStageId == SoStageId.Pick) {
            product.pickedQty = Number(product.originalQty) * Number(qty);
            product.totalQuantity = product.pickedQty;
        } else {
            product.packedQty = Number(product.originalQty) * Number(qty);
            product.totalQuantity = product.packedQty;
        }
    }

    addBundleProductsQtyAndCalculateTotal(product, qty, data) {
        this.changeProductsQty(product, qty, data);
        let subTaxes = this.getProductsApplicableSubTaxes(product, data.allTaxRates, data.zipCode, data.stateId, data.taxSettings);
        let subTotal = Number(product.price) * Number(product.totalQuantity);
        let productsTotalTax = 0;
        if (data.taxEnabled && data.isVisibleRowTax) {
            subTaxes?.forEach((sTax) => {
                productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
            });
        }
        product.subTotal = subTotal + productsTotalTax;
        product.taxAmount = productsTotalTax;
        product["bundleDetailSubTax"] = subTaxes;
    }

    getProductsApplicableSubTaxes(product, buyerTaxes, zipcode?, stateId?, taxSettings?, taxConfig?) {
        let allTaxRates = [];
        let yesTaxOutsideStates = taxSettings ? taxSettings.find((s) => s?.code == "YesTaxOutsideStates")?.enabled : false;
        let taxes = buyerTaxes?.filter((t) => t.statusId == Status.Active);
        let subTaxes = [];

        /**
         * Step 1: Check based on zipcode & product category
         */
        if (taxes && taxes.length > 0) {
            taxes.forEach((tax) => {
                let zipCodes = tax.zipCode && tax.zipCode.length > 0 ? tax.zipCode.split(",") : [];
                let zipcodeExists = zipCodes.includes(zipcode);
                if (zipcodeExists) {
                    let taxAdded = false;

                    // find tax by product category
                    product?.productCategory?.forEach((pCategory) => {
                        const rate = tax?.taxProductCategory?.find((c) => c.categoryId == pCategory.categoryId && c.statusId == Status.Active);
                        if (rate) {
                            subTaxes.push(tax);
                            taxAdded = true;
                        }
                    });

                    if (!taxAdded) {
                        let activeProductCategories = tax?.taxProductCategory?.find((c) => c.statusId == Status.Active);
                        if (!activeProductCategories) {
                            // no category defined in this tax
                            subTaxes.push(tax);
                        }
                    }
                }
            });
        }

        /**
         * Step 2: Check based on state & product category
         * if there is no tax defined based on zipcode , then second step is to check based on state & product category
         */
        if (taxes && taxes.length > 0 && subTaxes.length == 0) {
            allTaxRates = taxes.filter((t) => t.stateId == stateId);
            let taxAdded = false;

            // find tax by product category
            product?.productCategory?.forEach((pCategory) => {
                allTaxRates?.forEach((tax) => {
                    const rate = tax?.taxProductCategory?.find((c) => c.categoryId == pCategory.categoryId && c.statusId == Status.Active);
                    if (rate) {
                        subTaxes.push(tax);
                        taxAdded = true;
                    }
                });
            });

            // if product category wise no tax found, then default tax will be applied
            // in this case default tax is, state tax is defined without any category
            if (!taxAdded) {
                allTaxRates?.forEach((tax) => {
                    let activeProductCategories = tax?.taxProductCategory?.find((c) => c.statusId == Status.Active);
                    if (!activeProductCategories) {
                        // no category defined in this tax
                        subTaxes.push(tax);
                    }
                });
            }

            // yesTaxOutsideStates is set to true and no state tax is defined
            if (subTaxes?.length == 0 && yesTaxOutsideStates) {
                let defaultTax = allTaxRates?.find((t) => t.isDefault == true && t.statusId == Status.Active);
                if (defaultTax) {
                    subTaxes.push(defaultTax);
                }
            }
        }

        /**
         * Step 3: Check based on country & product category
         * if there is no tax defined based on zipcode & state , then third step is to check based on country & product category
         */
        if (taxes && taxes.length > 0 && subTaxes.length == 0) {
            allTaxRates = taxes.filter((t) => t.stateId == 0 && t.zipCode == ""); // country tax where state is not defined
            let taxAdded = false;

            // find tax by product category
            product?.productCategory?.forEach((pCategory) => {
                allTaxRates?.forEach((tax) => {
                    const rate = tax?.taxProductCategory?.find((c) => c.categoryId == pCategory.categoryId && c.statusId == Status.Active);
                    if (rate) {
                        subTaxes.push(tax);
                        taxAdded = true;
                    }
                });
            });

            // if product category wise no tax found, then default tax will be applied
            // in this case default tax is, country tax is defined without any category
            if (!taxAdded) {
                allTaxRates?.forEach((tax) => {
                    let activeProductCategories = tax?.taxProductCategory?.find((c) => c.statusId == Status.Active);
                    if (!activeProductCategories) {
                        // no category defined in this tax
                        subTaxes.push(tax);
                    }
                });
            }
        }

        /**
         * Step 4: Apply Default Tax
         */
        if (subTaxes.length == 0 && yesTaxOutsideStates) {
            if (taxConfig && taxConfig.length > 0) {
                taxConfig?.forEach((tc) => {
                    let tax = tc?.tax?.find((t) => t.isDefault == true && t.statusId == Status.Active);
                    if (tax) {
                        subTaxes.push(tax);
                    }
                });
            }
        }
        return subTaxes;
    }

    calculateProductsTax(taxRate: number, subTotal: number) {
        return subTotal * (Number(taxRate) / 100);
    }

    /**
     * onChangeBundleProductTaxOrDiscount is calculating inner product's subtotal of any Bundle
     * when products qty, tax, discount changed , then need to calculate subtotal based on that changes
     * also need to add addtional amount to bundles subtotal
     */
    onChangeBundleProductTaxOrDiscount(bundle, product, type, channelName, aggregateDiscount, allTaxRates, taxEnabled, isVisibleRowTax, stageId?, isConvertedFromEstimate?) {
        if (bundle.typeId == TypeIds.BundleTypeId) {
            bundle?.bundleDetails?.forEach((e) => {
                if (e.id == product.id) {
                    const uomValue = e?.unit?.uomDetail?.value || 1;
                    if (channelName == SOChannel.SALES_ORDER) {
                        e.totalQuantity = stageId == SoStageId.Entered ? Number(e.ordQty) * Number(uomValue) : stageId == SoStageId.Pick ? Number(e.pickedQty) * Number(uomValue) : Number(e.packedQty) * Number(uomValue);
                    } else {
                        e.totalQuantity = Number(e.ordQty) * Number(uomValue);
                    }

                    //Pricebook
                    if (type == "qty" && e.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                        e.price = this.applyPriceBook(aggregateDiscount, e, Number(e.ordQty) * Number(uomValue));
                    }

                    // tax
                    let subTotal = Number(e.totalQuantity) * Number(e.price);
                    e.baseSubTotal = subTotal;
                    let productsTotalTax = 0;
                    if (taxEnabled && isVisibleRowTax) {
                        e?.bundleDetailSubTax?.forEach((sTax) => {
                            productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                        });
                    }
                    e.subTotal = subTotal + productsTotalTax;
                    e.taxAmount = productsTotalTax;

                    // discount
                    let discount = this.calculateProductsDiscount(e?.discountType, e.totalQuantity, e.price, e.discount);
                    e.discountAmount = discount;
                    e.subTotal = Number(e.subTotal) - Number(discount);

                    let addFee = this.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e?.additionalFee);
                    e.additionalFeeAmount = addFee;
                    e.subTotal = e.subTotal + Number(addFee);
                }
            });

            // total of all products is the total of that bundle
            let total = 0;
            let totalOfBaseSubTotal = 0;
            let taxTotal = 0;
            bundle?.bundleDetails?.forEach((e) => {
                total += Number(e.subTotal);
                totalOfBaseSubTotal += Number(e.baseSubTotal);
                taxTotal += Number(e.taxAmount);
            });
            bundle.price = total;
            bundle.subTotal = total;
            bundle.baseSubTotal = totalOfBaseSubTotal;
            bundle.taxAmount = taxTotal;
        }
    }

    /**
     * Calculating individual inventory items subtotal that added in products list
     */
    calculateProductsSubTotal(product, dialogType, allTaxRates, channelName, aggregateDiscount, isEnabledRowTax, taxEnabled, stageId?, isConvertedFromEstimate?, isRowWiseAdditionalFeeEnabled?) {
        product.subTotal = 0;
        const uomValue = product?.unit?.uomDetail?.value || 1;

        /**
         * If product type is kit and parent items ordqty is changed
         * that should reflect in inner products ordqty
         *
         */
        if (product.typeId == TypeIds.KitTypeId) {
            if (channelName == SOChannel.SALES_ORDER) {
                let kitQty = 0;
                let kitCount = 0;
                let count = 0;
                product?.bundleDetails?.forEach((prd) => {
                    prd.subTotal = 0;
                    prd.baseSubTotal = 0;
                    if (stageId == SoStageId.Entered) {
                        if (dialogType == DialogType.CREATE) {
                            prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                            prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
                        } else {
                            prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                            prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
                        }
                        if (prd.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                            prd.price = this.applyPriceBook(aggregateDiscount, prd, prd.totalQuantity);
                        }
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                    } else if (stageId == SoStageId.Pick) {
                        prd.pickedQty = Number(product.pickedQty) * Number(prd.originalQty) * Number(uomValue);
                        prd.totalQuantity = Number(prd.pickedQty) * Number(prd.unit?.uomDetail?.value || 1);
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                    } else {
                        prd.packedQty = Number(product.packedQty) * Number(prd.originalQty) * Number(uomValue);
                        prd.totalQuantity = Number(prd.packedQty) * Number(prd.unit?.uomDetail?.value || 1);
                        prd.baseSubTotal = prd.totalQuantity * prd.price;
                        prd.subTotal = prd.totalQuantity * prd.price + Number(prd.taxAmount);
                    }

                    if (prd.typeId == TypeIds.InventoryTypeId || prd.typeId == TypeIds.KitTypeId || prd.typeId == TypeIds.BundleTypeId) {
                        if (count == 0) {
                            kitQty = Math.floor(prd.availabel / (prd.originalQty * (prd.unit?.uomDetail?.value || 1)));
                            kitCount = isNaN(kitCount) ? 0 : kitCount;
                            kitCount = kitQty < 0 ? 0 : kitQty;
                            count++;
                        } else if (count > 0) {
                            kitQty = Math.floor(prd.availabel / (prd.originalQty * (prd.unit?.uomDetail?.value || 1)));
                            kitCount = isNaN(kitCount) ? 0 : kitCount;
                            kitCount = kitQty <= kitCount && kitQty >= 0 ? kitQty : kitCount;
                            count++;
                        }
                    }

                    let discount = this.calculateProductsDiscount(prd?.discountType, prd.totalQuantity, prd.price, prd.discount);
                    prd.discountAmount = discount;
                    prd.subTotal = Number(prd.subTotal) - Number(discount);
                    product.subTotal = product.subTotal + prd.subTotal;
                });
                product.totalAvailInSelectedWareHouse = kitCount;
                product.availabel = kitCount;
            } else {
                product?.bundleDetails?.forEach((prd) => {
                    prd.subTotal = 0;
                    if (dialogType == DialogType.CREATE) {
                        prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                    } else {
                        prd.ordQty = Number(product.ordQty) * Number(prd.originalQty) * Number(uomValue);
                    }
                    prd.totalQuantity = Number(prd.ordQty) * Number(prd.unit?.uomDetail?.value || 1);
                    if (prd.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                        prd.price = this.applyPriceBook(aggregateDiscount, prd, prd.totalQuantity);
                    }
                    //kit/bundle under kit
                    prd?.bundleDetails?.forEach((kp) => {
                        const uomValueChild = prd?.unit?.uomDetail?.value || 1;
                        kp.subTotal = 0;
                        if (dialogType == DialogType.CREATE) {
                            kp.ordQty = Number(product.ordQty) * Number(kp.originalQty) * Number(uomValueChild) * Number(uomValue);
                        } else {
                            kp.ordQty = Number(product.ordQty) * Number(kp.originalQty) * Number(uomValueChild) * Number(uomValue);
                        }
                        kp.totalQuantity = Number(kp.ordQty) * Number(kp.unit?.uomDetail?.value || 1);
                        if (kp.accountPriceTier?.length > 0 && !isConvertedFromEstimate) {
                            kp.price = this.applyPriceBook(aggregateDiscount, kp, kp.totalQuantity);
                        }

                        let discount = this.calculateProductsDiscount(kp?.discountType, kp.totalQuantity, kp.price, kp.discount);
                        kp.discountAmount = discount;
                        kp.subTotal = Number(kp.subTotal) - Number(discount);
                        prd.subTotal = prd.subTotal + kp.subTotal;
                    });

                    let discount = this.calculateProductsDiscount(prd?.discountType, prd.totalQuantity, prd.price, prd.discount);
                    prd.discountAmount = discount;
                    prd.subTotal = Number(prd.subTotal) - Number(discount);
                    product.subTotal = product.subTotal + prd.subTotal;
                });
            }
        }

        if (product.typeId != TypeIds.BundleTypeId) {
            let subTotal = Number(product.totalQuantity) * Number(product.price);
            product.baseSubTotal = subTotal;

            if (product?.discountType?.isTaxable) {
                /** Discount */
                let discount = this.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
                product.discountAmount = discount;
                product.subTotal = Number(subTotal) - Number(discount);
                subTotal = Number(subTotal) - Number(discount);

                // taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    product.subTotal = Number(subTotal) + Number(discount);
                    subTotal = Number(subTotal) + Number(addFee);
                }

                /** tax */
                let productsTotalTax = 0;
                if (taxEnabled && isEnabledRowTax) {
                    let subTaxes = this.getProductsApplicableSubTaxes(product, allTaxRates);
                    subTaxes?.forEach((sTax) => {
                        productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                    });
                }
                product.subTotal = subTotal + productsTotalTax;
                product.taxAmount = productsTotalTax;

                // not taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && !product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, product.subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    product.subTotal = product.subTotal + Number(addFee);
                }
            } else {
                // taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    subTotal = subTotal + Number(addFee);
                }

                /** tax */
                let productsTotalTax = 0;
                if (taxEnabled && isEnabledRowTax) {
                    let subTaxes = this.getProductsApplicableSubTaxes(product, allTaxRates);
                    subTaxes?.forEach((sTax) => {
                        productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
                    });
                }
                product.subTotal = subTotal + productsTotalTax;
                product.taxAmount = productsTotalTax;
                /** Discount */
                let discount = this.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
                product.discountAmount = discount;
                product.subTotal = Number(product.subTotal) - Number(discount);

                // not taxable additional fee
                if (isRowWiseAdditionalFeeEnabled && !product?.additionalFeeType?.isTaxable) {
                    let addFee = this.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, product.subTotal, product?.additionalFee);
                    product.additionalFeeAmount = addFee;
                    product.subTotal = product.subTotal + Number(addFee);
                }
            }
        }
    }

    calculateProductWiseDiscount(disType: any, subTotal: number, discount: number) {
        let discountAmount = 0;
        if (subTotal == 0) {
            return discountAmount;
        }
        if (disType) {
            if (disType.description == "%" || disType.description?.toLowerCase() == "percentage") {
                discountAmount = subTotal * (Number(discount) / 100);
            } else if (disType.description == "$" || disType.description?.toLowerCase() == "amount") {
                discountAmount = discount;
            }
        }
        return discountAmount;
    }

    calculateProductWiseAdditionalFee(feeType: any, subTotal: number, fee: number) {
        let additionalFeeAmount = 0;
        if (feeType) {
            if (feeType == "%" || feeType?.toLowerCase() == "percentage") {
                additionalFeeAmount = subTotal * (Number(fee) / 100);
            } else if (feeType == "$" || feeType?.toLowerCase() == "amount") {
                additionalFeeAmount = fee;
            }
        }
        return additionalFeeAmount;
    }

    /**
     * calculateOrderTotalDiscount
     * checking row wise,footer's discount visibilty and calculating order total discount
     * based on discount visibility calculating order total discount amount
     */
    calculateOrderTotalDiscount(disName, disValue, sumTotal, purchaseListTB, isVisibleRowDiscount, footerDiscountEnabled, isVisibleFooterDiscount): number {
        let discount = 0;
        if (isVisibleRowDiscount && footerDiscountEnabled && isVisibleFooterDiscount) {
            if (disName == "%" || disName == "Percentage") {
                discount = Number(sumTotal * (Number(disValue) / 100));
            } else if (disName == "$" || disName == "Amount") {
                discount = Number(disValue);
            }
        } else {
            let discountTotal = 0;
            purchaseListTB?.forEach((e) => {
                if (e.typeId == TypeIds.BundleTypeId) {
                    e?.bundleDetails?.forEach((b) => {
                        discountTotal += Number(b.discountAmount);
                    });
                } else {
                    discountTotal += Number(e.discountAmount);
                }
            });
            discount = discountTotal;
        }
        return isNaN(discount) ? 0 : discount;
    }

    calculateOrderTotalAdditionalFee(feeName, feeAmount, sumTotal, purchaseListTB, isRowWiseAdditionalFeeEnabled, isFooterAdditionalFeeEnabled): number {
        let addFeeAmount = 0;
        if (isFooterAdditionalFeeEnabled) {
            if (feeName == "%" || feeName == "Percentage") {
                addFeeAmount = Number(sumTotal * (Number(feeAmount) / 100));
            } else if (feeName == "$" || feeName == "Amount") {
                addFeeAmount = Number(feeAmount);
            }
        }
        return isNaN(addFeeAmount) ? 0 : addFeeAmount;
    }
    calculateOrderTotalAdditionalFeeForPartialQty(feeName, feeAmount, sumTotal, purchaseListTB, isRowWiseAdditionalFeeEnabled, isFooterAdditionalFeeEnabled): number {
        let addFeeAmount = 0;
        if (!isRowWiseAdditionalFeeEnabled && isFooterAdditionalFeeEnabled) {
            if (feeName == "%" || feeName == "Percentage") {
                addFeeAmount = Number(sumTotal * (Number(feeAmount) / 100));
            } else if (feeName == "$" || feeName == "Amount") {
                addFeeAmount = Number(feeAmount);
            }
        } else if (isRowWiseAdditionalFeeEnabled) {
            purchaseListTB?.forEach((e) => {
                if (e.typeId == TypeIds.BundleTypeId) {
                    e?.bundleDetails?.forEach((b) => {
                        addFeeAmount += Number(b.additionalAmount);
                    });
                } else {
                    addFeeAmount += Number(e.additionalAmount);
                }
            });
        }
        return isNaN(addFeeAmount) ? 0 : addFeeAmount;
    }

    calculateConvertedInvoiceTotalDiscount(disName, disValue, sumTotal, purchaseListTB, isVisibleRowDiscount, footerDiscountEnabled, isVisibleFooterDiscount): number {
        let discount = 0;
        if (isVisibleRowDiscount && footerDiscountEnabled && isVisibleFooterDiscount) {
            if (disName == "%" || disName == "Percentage") {
                discount = Number(sumTotal * (Number(disValue) / 100));
            } else if (disName == "$" || disName == "Amount") {
                discount = Number(disValue);
            }
        } else {
            let discountTotal = 0;
            purchaseListTB?.forEach((e) => {
                if (e.typeId == TypeIds.BundleTypeId) {
                    e?.invoiceBundleDetail?.forEach((b) => {
                        discountTotal += Number(b.discountAmount);
                    });
                } else {
                    discountTotal += Number(e.discountAmount);
                }
            });
            discount = discountTotal;
        }
        return isNaN(discount) ? 0 : discount;
    }
    calculateConvertedInvoiceTotalTax(purchaseListTB: any[], subTotal, isEnabledRowTax, taxEnabled, isVisibleFooterTax, allTaxRates, isPartialQty?): number {
        let taxTotal = 0;
        if (taxEnabled) {
            // if row wise tax not enabled, then tax will be applied on subtotal
            if (!isEnabledRowTax) {

                if(isPartialQty){
                    const subTaxes: any[] = [];
                    purchaseListTB?.forEach((product) => {
                        if (product.typeId == TypeIds.BundleTypeId) {
                            product?.invoiceBundleDetail?.forEach((bProduct) => {
                                bProduct?.invoiceBundleDetailSubTax?.forEach((tax) => {
                                    const isApplied = subTaxes.find((sTax) => sTax.id == tax.id);
                                    if (!isApplied) {
                                        subTaxes.push(tax);
                                    }
                                    // taxTotal += this.calculateProductsTax(tax.taxRate, bProduct.subTotal);
                                });
                            });
                        } else {
                            product?.invoiceProductSubTax?.forEach((tax) => {
                                const isApplied = subTaxes.find((sTax) => sTax.id == tax.id);
                                if (!isApplied) {
                                    subTaxes.push(tax);
                                }
                                // taxTotal += this.calculateProductsTax(tax.taxRate, product.subTotal);
                            });
                        }
                    });
                    subTaxes?.forEach((tax) => {
                        taxTotal += this.calculateProductsTax(tax.taxRate, subTotal);
                    });
                }else {
                    purchaseListTB?.forEach((product) => {
                        if (product.typeId == TypeIds.BundleTypeId) {
                            product?.invoiceBundleDetail?.forEach((b) => {
                                const totalTaxAmount = b?.invoiceBundleDetailSubTax?.reduce((sum, item) => sum + item.taxAmount, 0);
                                taxTotal += Number(totalTaxAmount);
                            });
                        } else {
                            const totalTaxAmount = product?.invoiceProductSubTax?.reduce((sum, item) => sum + item.taxAmount, 0);
                            taxTotal += Number(totalTaxAmount);
                        }
                    });
                }
            } else {
                purchaseListTB?.forEach((product) => {
                    if (product.typeId == TypeIds.BundleTypeId) {
                        product?.invoiceBundleDetail?.forEach((b) => {
                            taxTotal += Number(b.taxAmount);
                        });
                    } else {
                        taxTotal += Number(product.taxAmount);
                    }
                });
            }
        }
        return taxTotal;
    }

    /**
     * calculateOrderTotalTax method is reponsible for calculating order total tax
     */
    calculateOrderTotalTax(purchaseListTB: any[], subTotal, isEnabledRowTax, taxEnabled, isVisibleFooterTax, allTaxRates): number {
        let taxTotal = 0;
        if (taxEnabled) {
            // if row wise tax not enabled, then tax will be applied on subtotal
            if (!isEnabledRowTax) {
                const subTaxes: any[] = [];
                purchaseListTB?.forEach((product) => {
                    if (product.typeId == TypeIds.BundleTypeId) {
                        product?.bundleDetails?.forEach((bProduct) => {
                            bProduct?.bundleDetailSubTax?.forEach((tax) => {
                                let isAppliedBundleProductTax = null;
                                if (tax.taxId) {
                                    isAppliedBundleProductTax = subTaxes.find((sTax) => sTax.taxId == tax.taxId);
                                } else {
                                    isAppliedBundleProductTax = subTaxes.find((sTax) => sTax.id == tax.id);
                                }
                                if (!isAppliedBundleProductTax) {
                                    subTaxes.push(tax);
                                }
                            });
                        });
                    } else {
                        product?.productSubTax?.forEach((tax) => {
                            let isAppliedProductTax = null;
                            if (tax.taxId) {
                                isAppliedProductTax = subTaxes.find((sTax) => sTax.taxId == tax.taxId);
                            } else {
                                isAppliedProductTax = subTaxes.find((sTax) => sTax.id == tax.id);
                            }
                            if (!isAppliedProductTax) {
                                subTaxes.push(tax);
                            }
                        });
                    }
                });
                subTaxes?.forEach((tax) => {
                    taxTotal += this.calculateProductsTax(tax.taxRate, subTotal);
                });
            } else {
                purchaseListTB?.forEach((product) => {
                    if (product.typeId == TypeIds.BundleTypeId) {
                        product?.bundleDetails?.forEach((b) => {
                            taxTotal += Number(b.taxAmount);
                        });
                    } else {
                        taxTotal += Number(product.taxAmount);
                    }
                });
            }
        }
        return taxTotal;
    }

    calculateProductsDiscount(disType: any, totalQty: number, price: number, discount: number) {
        let discountAmount = 0;
        if (price == 0) {
            return discountAmount;
        }
        if (disType) {
            if (disType.description == "%" || disType.description?.toLowerCase() == "percentage") {
                discountAmount = (Number(totalQty) * Number(price) * Number(discount)) / 100;
            } else if (disType.description == "$" || disType.description?.toLowerCase() == "amount") {
                discountAmount = discount;
            }
        }
        return discountAmount;
    }

    getTaxByAddress(countryId: number, stateId: number, orgHeadOfficeAddress, sellerTaxes, buyerTaxes, taxSettings?): any[] {
        let allTaxRates = [];
        let noTaxOutsideStates = taxSettings ? taxSettings.find((s) => s?.code == "NoTaxOutsideStates")?.enabled : true;
        let taxes = buyerTaxes?.filter((t) => t.statusId == Status.Active);
        // only defined states tax is applicable
        if (noTaxOutsideStates) {
            if (taxes && taxes.length > 0) {
                allTaxRates = taxes.filter((t) => t.stateId == stateId);
                if (!allTaxRates || allTaxRates.length == 0) {
                    allTaxRates = taxes.filter((t) => t.stateId == 0); // country tax where state is not defined
                }
            }
        }
        // outside of defined states tax can be applicable
        else {
            // todo
            // if(taxes && taxes.length > 0){
            //     allTaxRates = taxes.filter(t => t.stateId == stateId);
            //     if(!allTaxRates || allTaxRates.length == 0){
            //         allTaxRates = taxes.filter(t => t.stateId == 0); // country tax where state is not defined
            //     }
            // }
        }
        // console.log('applicable tax ==>>', allTaxRates);
        // return allTaxRates && allTaxRates.length > 0 ? allTaxRates : [];
        return []; // remove when tax implemented so and estimates
    }

    /**
     * for conversion
     * estimates to so/invoice
     * sales order to invoice
     */
    getProductsTotalTax(product, allTaxRates, subTotal, zipcode?, stateId?, taxSettings?, taxConfig?) {
        let subTaxes = this.getProductsApplicableSubTaxes(product, allTaxRates, zipcode, stateId, taxSettings, taxConfig);
        let productsTotalTax = 0;
        subTaxes?.forEach((sTax) => {
            productsTotalTax += this.calculateProductsTax(sTax.taxRate, subTotal);
        });
        return productsTotalTax;
    }

    //Auto-Generate Serial Tracking
    generateSerialNo(length) {
        let result = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    /**
     * If product's/row wise discount is disabled from template
     * then, total discount should be divided on each product based on product's total amount
     */
    calculateDiscountPerProduct(productTotalAmount: number, sumTotal: number, totalDiscountAmount: number) {
        let discount = 0;
        if (productTotalAmount > 0 && sumTotal > 0 && totalDiscountAmount > 0) {
            let discountPercentage = (productTotalAmount / sumTotal) * 100;
            discount = (discountPercentage / 100) * totalDiscountAmount;
        }
        return discount;
    }

    /** Fetch Tax Settings */
    async getTaxByCountryId(countryId: number) {
        const iSettings = await lastValueFrom(this.settingService.getAllInventorySettings());
        const taxSettings = iSettings?.find((s) => s?.code?.toLowerCase() == "tax")?.childInventorySettings;
        let allTaxRates = await lastValueFrom(this.salesOrderService.getTaxByAddress(countryId));
        let tax = await lastValueFrom(this.salesOrderService.getAllTax());
        const taxConfig = tax?.item2 && tax?.item2?.length > 0 ? tax?.item2 : [];

        if (!allTaxRates) {
            allTaxRates = [];
            if (taxConfig && taxConfig.length > 0) {
                taxConfig?.forEach((tc) => {
                    let tax = tc?.tax?.find((t) => t.isDefault == true && t.statusId == Status.Active);
                    if (tax) {
                        allTaxRates.push(tax);
                    }
                });
            }
        }
        return { taxSettings: taxSettings, allTaxRates: allTaxRates, taxConfig: taxConfig };
    }

    /** Shipping method */
    prepareShippingMethods(methods: any[]) {
        let shippingMethods = [];
        for (let method of methods) {
            let shippingMethod = {
                id: method.id,
                label: method.name,
                value: method,
                children: this.prepareShippingMethodChildren(method),
                selectable: true,
                financialAccountId: method.financialAccountId ?? 0,
                description: method.description ?? 0,
                isDefault: method.isDefault,
            };
            shippingMethods.push(shippingMethod);
        }
        return shippingMethods;
    }
    prepareShippingMethodChildren(method: any) {
        let children = [];
        for (let child of method.childShippingMethod) {
            let childData = {
                id: child.id,
                label: child.name,
                value: child,
                children: this.prepareShippingMethodChildren(child),
                selectable: true,
                financialAccountId: child.financialAccountId ?? 0,
                description: child.description ?? "",
                isDefault: child.isDefault,
            };
            children.push(childData);
        }
        return children;
    }

    findShippingMethodById(methods: any[], id: number): any {
        for (const method of methods) {
            if (method.id === id) {
                return method;
            }
            if (method.children && method.children.length > 0) {
                const foundMethod = this.findShippingMethodById(method.children, id);
                if (foundMethod) {
                    return foundMethod;
                }
            }
        }
        return null;
    }
    /** End Shipping method */

    /** Products serial details check */
    checkProductsSerialTracking(products: any[], stageId: number, soDetails: any): boolean {
        let hasSerialTracking = true;
        let allowtracking = this.getISettings()?.find((s) => s?.code?.toLowerCase() == "allowtracking");
        let serialValidation = allowtracking?.childInventorySettings?.find((s) => s?.code?.toLowerCase() == "serialvalidation");
        if (serialValidation?.enabled && serialValidation?.restrictStageChange) {
            let serialTrackingStageId = serialValidation?.stageId ?? 0;
            if (serialTrackingStageId == SoStageId.Shipped && stageId == SoStageId.Shipped) {
                hasSerialTracking = this.hasProdutsSerialTracking(products, soDetails);
            } else if (serialTrackingStageId == SoStageId.ReadyToShip && stageId == SoStageId.Shipped) {
                hasSerialTracking = this.hasProdutsSerialTracking(products, soDetails);
            } else if (serialTrackingStageId == SoStageId.Labelling && (stageId == SoStageId.ReadyToShip || stageId == SoStageId.Shipped)) {
                hasSerialTracking = this.hasProdutsSerialTracking(products, soDetails);
            } else if (serialTrackingStageId == SoStageId.Verification && (stageId == SoStageId.Labelling || stageId == SoStageId.ReadyToShip || stageId == SoStageId.Shipped)) {
                hasSerialTracking = this.hasProdutsSerialTracking(products, soDetails);
            } else if ((serialTrackingStageId == SoStageId.Pick || serialTrackingStageId == SoStageId.Pack) && stageId > serialTrackingStageId) {
                hasSerialTracking = this.hasProdutsSerialTracking(products, soDetails);
            }
        }
        return hasSerialTracking;
    }
    hasProdutsSerialTracking(products: any[], soDetails: any): boolean {
        let hasSerialTracking = true;
        let enableserial = this.getISettings()?.find((s) => s?.code?.toLowerCase() == "enableserial");
        let delSerialNo = enableserial?.childInventorySettings?.find((s) => s?.code?.toLowerCase() == "delserialno");

        if (delSerialNo?.enabled) {
            for (let product of products) {
                if ((product?.product?.typeId == TypeIds.InventoryTypeId || product?.product?.typeId == TypeIds.KitTypeId) && product?.product?.isTrackingRequired && product?.salesOrderSerialDetail?.length != product.totalQty) {
                    hasSerialTracking = false;
                } else if (product?.product?.typeId == TypeIds.BundleTypeId) {
                    for (let bProduct of product?.salesOrderBundleDetail) {
                        if (bProduct?.product?.isTrackingRequired && bProduct?.salesOrderBundleProductSerialDetail?.length != bProduct.totalQty) {
                            hasSerialTracking = false;
                        }
                    }
                }
            }
        } else {
            let serialCount = soDetails?.notMatchedSerialNumbers?.length ?? 0;
            let totalOrdQty = 0;
            for (let product of products) {
                if ((product?.product?.typeId == TypeIds.InventoryTypeId || product?.product?.typeId == TypeIds.KitTypeId) && product?.product?.isTrackingRequired) {
                    totalOrdQty += Number(product?.totalQty ?? 0);
                    serialCount += product?.salesOrderSerialDetail?.length ?? 0;
                } else if (product?.product?.typeId == TypeIds.BundleTypeId) {
                    for (let bProduct of product?.salesOrderBundleDetail) {
                        if (bProduct?.product?.isTrackingRequired) {
                            totalOrdQty += Number(bProduct.totalQty ?? 0);
                            serialCount += bProduct?.salesOrderBundleProductSerialDetail?.length ?? 0;
                        }
                    }
                }
            }
            hasSerialTracking = serialCount < totalOrdQty ? false : true;
        }
        return hasSerialTracking;
    }
    hasProdutsSerialTrackingToCreateInvoice(products: any[], details: any, channel: string): boolean {
        let hasSerialTracking = true;
        let allowtracking = this.getISettings()?.find((s) => s?.code?.toLowerCase() == "allowtracking");
        let serialValidation = allowtracking?.childInventorySettings?.find((s) => s?.code?.toLowerCase() == "serialvalidation");
        let enableserial = this.getISettings()?.find((s) => s?.code?.toLowerCase() == "enableserial");
        let delSerialNo = enableserial?.childInventorySettings?.find((s) => s?.code?.toLowerCase() == "delserialno");

        if (serialValidation?.enabled) {
            if (delSerialNo?.enabled) {
                for (let product of products) {
                    if (((channel == SOChannel.SALES_ORDER && product?.typeId == TypeIds.InventoryTypeId) || product?.typeId == TypeIds.KitTypeId) && product?.isTrackingRequired && product?.salesOrderSerialDetails?.length != product.totalQuantity) {
                        hasSerialTracking = false;
                    } else if (channel == SOChannel.SALES_ORDER && product?.typeId == TypeIds.BundleTypeId) {
                        for (let bProduct of product?.bundleDetails) {
                            if (bProduct?.isTrackingRequired && bProduct?.salesOrderBundleProductSerialDetail?.length != bProduct.totalQuantity) {
                                hasSerialTracking = false;
                            }
                        }
                    } else if (((channel == SOChannel.INVOICING && product?.typeId == TypeIds.InventoryTypeId) || product?.typeId == TypeIds.KitTypeId) && product?.trackingEnabled && product?.invoiceProductSerialDetails?.length != product.totalQuantity) {
                        hasSerialTracking = false;
                    } else if (channel == SOChannel.INVOICING && product?.typeId == TypeIds.BundleTypeId) {
                        for (let bProduct of product?.bundleDetails) {
                            if (bProduct?.trackingEnabled && bProduct?.invoiceBundleProductSerialDetail?.length != bProduct.totalQuantity) {
                                hasSerialTracking = false;
                            }
                        }
                    }
                }
            } else {
                let serialCount = details?.notMatchedSerialNumbers?.length ?? 0;
                let totalOrdQty = 0;
                for (let product of products) {
                    if (((channel == SOChannel.SALES_ORDER && product?.typeId == TypeIds.InventoryTypeId) || product?.typeId == TypeIds.KitTypeId) && product?.isTrackingRequired) {
                        totalOrdQty += Number(product?.totalQuantity ?? 0);
                        serialCount += product?.salesOrderSerialDetails?.length ?? 0;
                    } else if (channel == SOChannel.SALES_ORDER && product?.typeId == TypeIds.BundleTypeId) {
                        for (let bProduct of product?.bundleDetails) {
                            if (bProduct?.isTrackingRequired) {
                                totalOrdQty += Number(bProduct.totalQuantity ?? 0);
                                serialCount += bProduct?.salesOrderBundleProductSerialDetail?.length ?? 0;
                            }
                        }
                    } else if (((channel == SOChannel.INVOICING && product?.typeId == TypeIds.InventoryTypeId) || product?.typeId == TypeIds.KitTypeId) && product?.trackingEnabled) {
                        totalOrdQty += Number(product?.totalQuantity ?? 0);
                        serialCount += product?.invoiceProductSerialDetails?.length ?? 0;
                    } else if (channel == SOChannel.INVOICING && product?.typeId == TypeIds.BundleTypeId) {
                        for (let bProduct of product?.bundleDetails) {
                            if (bProduct?.trackingEnabled) {
                                totalOrdQty += Number(bProduct.totalQuantity ?? 0);
                                serialCount += bProduct?.invoiceBundleProductSerialDetail?.length ?? 0;
                            }
                        }
                    }
                }
                hasSerialTracking = serialCount < totalOrdQty ? false : true;
            }
        }
        return hasSerialTracking;
    }
    /** End Products serial details check */

    prepareDiscountOptions(addDiscounts): any[] {
        let discountOptions = addDiscounts?.map((l) => ({
            id: l?.id ?? 0,
            discountCategoryId: l?.discountCategoryId ?? 0,
            discountBy: l?.discountBy,
            name: l?.type?.name ?? "",
            parentTypeId: l?.type?.parentTypeId ?? 0,
            description: l?.type?.description ?? "",
            additionalDescription: `${l?.description ?? ""}(${l?.type?.description ?? ""})`,
            groupId: l?.type?.groupId ?? 0,
            group: l?.type?.group,
            organizationId: l?.organizationId ?? 0,
            colorCodeId: l?.type?.colorCodeId ?? 0,
            statusId: l?.statusId ?? 0,
            status: l?.status,
            isDefault: l?.type?.isDefault ?? false,
            oldRecordId: l?.type?.oldRecordId ?? 0,
            discountValue: l?.discountValue ?? 0,
            expenseAccount: l?.expenseAccount ?? 0,
            incomeAccount: l?.incomeAccount ?? 0,
            isCoupanCode: l?.isCoupanCode ?? false,
            isCumulative: l?.isCumulative ?? false,
            isTaxable: l?.isTaxable ?? false,
            isValid: l?.isValid ?? false,
            createdSource: l?.createdSource ?? "",
            updatedSource: l?.updatedSource ?? "",
            createdBy: l?.createdBy ?? "",
            updatedBy: l?.updatedBy ?? "",
            createdDate: l?.createdDate ?? "",
            updatedDate: l?.updatedDate ?? "",
            validFromDate: l?.validFromDate ?? "",
            validToDate: l?.validToDate ?? "",
        }));
        return discountOptions;
    }
    showTrackingOption(trackingOptions: any[], option: string, savedOption: any): boolean {
        if (savedOption) {
            if (savedOption[`${option}`]) {
                return trackingOptions?.some((track) => track.code === option && track.enabled);
            } else {
                return false;
            }
        } else {
            return trackingOptions?.some((track) => track.code === option && track.enabled);
        }
    }

    displayName(code, trackingOptions, type) {
        if (type === "label") {
            return trackingOptions?.find((opt) => opt.code == code)?.name;
        } else if (type === "currency") {
            return trackingOptions?.find((opt) => opt.code == code)?.currencySymbol;
        } else {
            return trackingOptions?.find((opt) => opt.code == code)?.formControlName;
        }
    }

    getDecimalValue(trackingOptions: any[], code) {
        return trackingOptions?.find((opt) => opt.code == code)?.noOfDecimal;
    }

    checkRequiredValidation(code, trackingOptions) {
        return trackingOptions?.find((el) => el.code === code)?.isRequired || false;
    }

    allowPositiveNumberOnly(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }
    allowPositiveOrNegativeNumber(evt) {
        var charCode = evt?.which ? evt?.which : evt?.keyCode;
        var value = evt?.target?.value ? evt?.target?.value : evt?.value;

        // Allow minus sign if it's the first character
        if (charCode === 45 && (value?.length === 0 || value?.indexOf("-") !== -1 || evt.target.selectionStart === 0)) {
            return true;
        }

        if (charCode >= 48 && charCode <= 57) {
            return true;
        }
        return false;
    }

    // find section by type
    getFilteredSectionsByType(typeId: number): Observable<any[]> {
        return this.orderSectionsService.sections$.pipe(map((sections) => sections.filter((section) => section.typeId === typeId)));
    }

    prepareSalesOrderSerialDetailsData(data: Array<any>) {
        const lotNumbers = new Set<string>();
        const revisionNumbers = new Set<string>();
        const barcodes = new Set<string>();

        data?.forEach((item) => {
            if (item.lotNumber) lotNumbers.add(item.lotNumber);
            if (item.revisionNumber) revisionNumbers.add(item.revisionNumber);
            if (item.barcode) barcodes.add(item.barcode);
        });

        const lotNumber = Array.from(lotNumbers).join(", ");
        const revisionNumber = Array.from(revisionNumbers).join(", ");
        const serialNumber = Array.from(barcodes).join(", ");

        return { lotNumber, revisionNumber, serialNumber };
    }

    setTotalCostPrice(products: any[]) {
        const updatePrices = (item: any) => {
            const updatedItem = {
                ...item,
                totalCostPrice: Number(item?.costPrice ?? 0) * Number(item?.totalQuantity ?? 1),
                selectedBin: this.setBin(item.totalQuantity, item.binDetails),
            };

            if (updatedItem?.bundleDetails && updatedItem?.bundleDetails?.length > 0) {
                updatedItem.bundleDetails = updatedItem.bundleDetails.map((bundleItem) => updatePrices(bundleItem));
            }
            return updatedItem;
        };
        return products.map((item) => updatePrices(item));
    }

    convertProductPriceByExchangeRate(products: any[], exchangeRate: number) {
        const updatePrices = (item: any) => {
            const updatedItem = {
                ...item,
                price: item.price * exchangeRate,
                baseprice: item.baseprice * exchangeRate,
                cost: item.cost * exchangeRate,
                costPrice: item.costPrice * exchangeRate,
                totalCostPrice: item.totalCostPrice * exchangeRate,
            };

            if (updatedItem?.bundleDetails && updatedItem?.bundleDetails?.length > 0) {
                updatedItem.bundleDetails = updatedItem.bundleDetails.map((bundleItem) => updatePrices(bundleItem));
            }
            return updatedItem;
        };
        return products.map((item) => updatePrices(item));
    }
    reConvertProductPriceByExchangeRate(products: any[], exchangeRate: number = 1, previousExchangeRate: number = 0) {
        const updatePrices = (item: any) => {
            const updatedItem = {
                ...item,
                price: previousExchangeRate !== 0 ? (Number(item.price) * exchangeRate) / previousExchangeRate : item.price,
                baseprice: previousExchangeRate !== 0 ? (Number(item.baseprice) * exchangeRate) / previousExchangeRate : item.baseprice,
                cost: previousExchangeRate !== 0 ? (Number(item.cost) * exchangeRate) / previousExchangeRate : item.cost,
                costPrice: previousExchangeRate !== 0 ? (Number(item.costPrice) * exchangeRate) / previousExchangeRate : item.costPrice,
                totalCostPrice: previousExchangeRate !== 0 ? (Number(item.totalCostPrice) * exchangeRate) / previousExchangeRate : item.totalCostPrice,
            };

            if (updatedItem?.bundleDetails && updatedItem?.bundleDetails?.length > 0) {
                updatedItem.bundleDetails = updatedItem.bundleDetails.map((bundleItem) => updatePrices(bundleItem));
            }
            return updatedItem;
        };
        return products.map((item) => updatePrices(item));
    }
}
